import { createBloomreachApiUrl } from '../utils/create-api-url.js';
import { createPath } from '../utils/create-path.js';
import { brHttpClient } from '../utils/http-client.js';

const createConfiguration = ({ apiUrl , path , options  })=>{
    const { headers ={} , connection , visitor , locale , isMultilingual  } = options;
    if (!apiUrl) {
        throw new Error(`Invalid Bloomreach API Url to fetch a page. Received apiUrl: ${apiUrl}`);
    }
    if (!path) {
        throw new Error(`Invalid path to fetch a page. Received path: ${path}`);
    }
    if (isMultilingual && !locale) {
        throw new Error(`Invalid locale when isMultilingual flag is set to true. Received locale: ${locale}`);
    }
    const currentLocale = isMultilingual ? locale : undefined;
    const cmsBaseUrl = createBloomreachApiUrl(apiUrl, currentLocale);
    const parsedPath = createPath(path, currentLocale);
    const request = {
        path: parsedPath
    };
    if (connection) {
        request.connection = connection;
    }
    if (headers['x-forwarded-for']) {
        request.headers = {
            'x-forwarded-for': headers['x-forwarded-for']
        };
    }
    const { origin  } = new URL(apiUrl);
    const configuration = {
        cmsBaseUrl,
        visitor,
        request,
        httpClient: brHttpClient,
        origin: origin.replace('www', 'cms')
    };
    if (process.env.NODE_ENV !== 'production') {
        console.log(`Fetching: ${cmsBaseUrl}/resourceapi${parsedPath}`);
    }
    return configuration;
};

export { createConfiguration };
//# sourceMappingURL=configuration.js.map
